import React from 'react';
import cx from "classnames";
import PropTypes from "prop-types";

const CheckboxD1 = ({className, label, handleChange, position, checked, ...props}) => {

	const classes = cx(
		'form-field',
		position && `form-field--position-${position}`,
		className
	);

	return (
		<div className={classes}>
			<label className="form-field__checkbox">
				{(label && position === 'left') && (
					<div className="form-field__label">{label}</div>
				)}
				<input
					{...props}
					type="checkbox"
					className="form-field__checkbox-input"
					checked={checked}
					onChange={handleChange}
				/>
				<div className="form-field__checkbox-mask"/>
				{(label && position === 'right') && (
					<div className="form-field__label">{label}</div>
				)}
			</label>
		</div>
	);
};

CheckboxD1.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	position: PropTypes.oneOf(["left", "beet"]),
};

CheckboxD1.defaultProps = {
	className: null,
	label: null,
	position: 'beet'
};

export default CheckboxD1;
